// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const DevboxError: MarkdocTagRegistration = {
  tag: 'devbox-error',
  component: 'DevboxError',
  attributes: {
    error: {
      type: Object,
      description: 'The error that occurred during development',
    },
  },
};
